import type { ModalProps } from '@/components/providers/ModalProvider/ModalProvider';
import type { Party } from '@/features/party/types';

import type {
  CreateTaskVariables,
  CreateTaskVariablesAnva,
  CreateTaskVariablesAssu,
  CreateTaskVariablesBrio,
  CRM,
} from '../../types';

import CreateTaskModalAnva from './CreateTaskModalAnva';
import CreateTaskModalAssu from './CreateTaskModalAssu';
import CreateTaskModalBrio from './CreateTaskModalBrio';
import CreateTaskModalDias from './CreateTaskModalDias';
import CreateTaskModalFasterForward from './CreateTaskModalFasterForward';

type Props = ModalProps & {
  crm: CRM;
  defaultValues?: Partial<
    CreateTaskVariables &
      CreateTaskVariablesAnva &
      CreateTaskVariablesAssu &
      Omit<CreateTaskVariablesBrio, 'priority'>
  >;
  party: Maybe<Party>;
};

export default function CreateTaskModal({
  onClose,
  crm,
  defaultValues,
  party,
}: Props) {
  switch (crm) {
    case 'anva':
      return (
        <CreateTaskModalAnva
          onClose={onClose}
          party={party}
          defaultValues={defaultValues}
        />
      );
    case 'dias':
      return (
        <CreateTaskModalDias
          onClose={onClose}
          party={party}
          defaultValues={defaultValues}
        />
      );
    case 'assu':
      return (
        <CreateTaskModalAssu
          onClose={onClose}
          party={party}
          defaultValues={defaultValues}
        />
      );
    case 'brio':
      return (
        <CreateTaskModalBrio
          onClose={onClose}
          party={party}
          defaultValues={defaultValues}
        />
      );
    case 'fasterforward':
      return (
        <CreateTaskModalFasterForward
          onClose={onClose}
          party={party}
          defaultValues={defaultValues}
        />
      );
    default:
      return null;
  }
}
